import { TableSizeTheme } from './types';

export const TABLE_SIZES = {
  LARGE: 'LARGE',
  MEDIUM: 'MEDIUM',
  SMALL: 'SMALL',
} as const;

export const TABLE_SIZE_THEMES: Record<
  keyof typeof TABLE_SIZES,
  TableSizeTheme
> = {
  [TABLE_SIZES.LARGE]: {
    size: TABLE_SIZES.LARGE,
    rowHeight: 64,
    cellPadding: 16,
    iconCellWidth: 52,
  },
  [TABLE_SIZES.MEDIUM]: {
    size: TABLE_SIZES.MEDIUM,
    rowHeight: 48,
    cellPadding: 16,
    iconCellWidth: 52,
  },
  [TABLE_SIZES.SMALL]: {
    size: TABLE_SIZES.SMALL,
    rowHeight: 36,
    cellPadding: 8,
    iconCellWidth: 44,
  },
} as const;

export const STICKY_TYPES = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;
